query student($id: ID!, $tz: String) {
  student(id: $id) {
    id
    communicationCount
    first
    gradeLevel {
      canCurrentDelete
      name
      color {
        id
        name
      }
      icon {
        id
        name
      }
      id
      order
      orderDenominator
      orderNumerator
      studentCount
      team {
        id
        name
      }
    }
    groups {
      id
      name
      teacher {
        id
        first
        last
        isCurrent
      }
      studentList {
        count
      }
    }
    homeNumbers {
      id
      label
      formattedNumber
      homeLanguage {
        id
        name
      }
    }
    last
    mostRecentCommunication
    positivity
    archivedAt(tz: $tz)
    archivingTeacher {
      id
      first
      isCurrent
      last
    }
    schoolIdentifier
    deletedAt(tz: $tz)
    deletingTeacher {
      id
      first
      isCurrent
      last
    }
  }
}
